<template>
  <div class="mssagePop" v-if="list.length > 0">
    <div class="po-title">消息和公告</div>
    <div class="po-ul">
      <div
        class="po-li pot"
        @click="lookNews(item)"
        v-for="(item, key) in list"
        :key="key"
      >
        <div class="li-config">
          <div class="po-li-title">
            <!-- <div class="wd-icon" :class="{'fd-icon':item.messageStatus=='read'}"></div> -->
            <div class="wd-title line-1" v-html="item.gg">
              
            </div>
           
          </div>
          <div class="po-li-timer" v-html="item.gmtModified"></div>
        </div>
      </div>
      <div class="pot po-bottom lan" @click="navto()">查看更多</div>
    </div>
    <NewsModal v-model="ismodel" :curItemDetail="curItemDetail" />
  </div>
</template>
<script>
import api from "@/api";
import NewsModal from "@/components/news-modal.vue";
export default {
  components: { NewsModal },
  data() {
    return {
      ismodel: false,
      curItemDetail: {},
      isshow: false,
    };
  },
  computed: {
    list() {
    
      let list1=this.$c.deepClone(this.$store.state.list)
       
        list1=list1.map(item=>{
          item.gg=item.messageType == "notice" ? "【公告】" : "【消息】"
           item.gg=item.gg+this.removeSpanTags(item.messageTitle)
          
           return item
          })

      return list1;
    },
  },
  mounted() {},
  methods: {
    removeSpanTags(inputString) {
  // 使用正则表达式匹配并移除<span>标签及其属性，保留内容
 
  var resultString = inputString.replace(/<span[^>]*>(.*?)<\/span>/g, "$1");
  return resultString;
},
    navto() {
      this.$router.push("/system/news");
      this.$emit("systemnew");
    },
    async lookNews(data) {
      this.curItemDetail = this.$c.deepClone(data);
      if (data.messageType == "notice") {
        this.curItemDetail.title = "公告";
      } else {
        this.curItemDetail.title = "消息";
      }
      let data1 = await api.axss(
        "get",
        `/ocm-admin/messageCenter/getDetails/${data.id}`
      );
      data.messageStatus = "read";

      this.ismodel = true;
      this.$emit("on-open-modal");
    },
    init() {
      api
        .axss("post", "/ocm-admin/messageCenter/messageCenterList", {
          size: 4,
          current: 1,
          messageStatus: "unread",
        })
        .then((res) => {
          this.list = res.data.records.map(item=>{
           e.gg=item.messageType == "notice" ? "公告" : "消息"
           e.gg=e.gg+item.messageTitle
          
           return e
          })
          console.log("list",list)
          if (this.list.length == 0) {
            this.isshow = false;
          } else {
            this.isshow = true;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.mssagePop {
  position: absolute;
  top: 41px;
  left: -219px;
  width: 268px;

  background: #ffffff;
  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.1608);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #ebebeb;
  .po-title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    font-size: 12px;
    font-weight: 400;
    color: #000000;
    background: rgba(230, 230, 230, 0.35);
  }
  .po-ul {
    background: #ffffff;
    .po-li {
      border-bottom: 1px solid #e9e9e9;
      .li-config {
        padding: 12px 20px;
      }
      .po-li-title {
        display: flex;
        align-items: center;
        font-size: 12px;

        font-weight: 400;
        color: #555555;
        line-height: 1;
        .wd-icon {
          width: 6px;
          height: 6px;
          background: #f5222d;
          opacity: 1;
          border-radius: 50%;
        }
        .fd-icon {
          background: #c6c6c6 !important;
        }
      }
      .po-li-timer {
        font-size: 12px;

        font-weight: 400;
        color: #555555;
        line-height: 1;
        margin-top: 4px;
      }
    }
  }
  .po-bottom {
    line-height: 1;
    padding: 20px;
    font-size: 12px;
    font-weight: 400;
    color: rgb(12, 71, 157);
  }
}

.wd-title {
  width: 100%;
  position: relative;
  left: -5px;
}
</style>